const Invoice = {

    // FIELDS
    "customer": "Customer",
    "delivery_note": "Delivery Note",
    "date": "Date",
    "search": "Search",
    "item": "Item",
    "rate": "Rate",
    "quantity": "Quantity",
    "unit": "Unit",
    "vat": "VAT (%)",
    "sub_total": "Sub Total",
    "discount": "Discount (%)",
    "remark": "Remark",
    "total": "Total",

    // PAGE HEADER
    "invoice": "Invoice",

    // TOOLTIP
    "payment": "Payment",
    "history": "History",

    // ERROR
    "error_customer": "Select Customer",
    "error_delivery_note": "Select Delivery Note",
    "error_date": "Choose Date",

    // TABLE HEADER
    "table_invoice_code": "INVOICE CODE",
    "table_customer": 'CUSTOMER',
    "table_date": 'DATE',

}

export default Invoice;